import { getPanelSmallImage } from '../utils';
import ThumbnailComponent from '72cms-ui/components/table-elements/ThumbnailComponent';
import LinkTitleComponent from '72cms-ui/components/table-elements/LinkTitleComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';
import CustomFilterComponent from '72cms-ui/components/helpers/CustomFilterComponent';
import { getPanelLabel, getPanelOptions } from '../utils';

export default {
    fields: {
        image: {
            component: {
                template: `<a :href="'#' + _.get(data, 'link')"><img :src="iconImage" /></a>`,
                props: ['data'],
                computed: {
                    iconImage() {
                        const type = _.get(this.data, 'type');
                        return getPanelSmallImage(type);
                    }
                }
            },
        },
        type: {
            component: {
                template: `<span>{{ value }}</span>`,
                props: ['initialValue'],
                computed: {
                    value() {
                        return getPanelLabel(this.initialValue);
                    }
                }
            }
        },
        name: {
            component: LinkTitleComponent,
        },
    },
    sortable: [],
    filterable: [],
    customFilters: [
        {
            name: 'Type',
            component: CustomFilterComponent,
            key: 'type',
            values: getPanelOptions([
                'banner',
                'contact-address',
                'footer-panel',
                'form',
                'slideshow',
                'text-content',
                'text-image',
                'text-panel',

            ]),
        },
    ],
    toolbar: ['create'],
    pagination: true,
    searchable: true,
    treeView: false,
    batchActions: [
        'active', 'delete',
    ],
    actions: [
        {
            name: 'edit',
            primary: true,
            component: 'edit-button',
        },
        {
            name: 'active',
            primary: true,
            component: ActiveSwitchActionComponent,
        },
        {
            name: 'delete',
            component: 'delete-button',
            primary: true,
        },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.panels.js